import { AxiosPromise } from 'axios';
import useAxios from 'axios-hooks';
import { ScheduleBaseModel } from '../../../models';
import { AxiosMethod, defaultAxiosOptions } from '../../../constants';
import { ResponseValuesOverride } from '../../../models/response-values-override';

export function useSaveOfferGeoSchedules(
  endpoint: string,
): [
  ResponseValuesOverride<ScheduleBaseModel[]>,
  (
    data: ScheduleBaseModel[],
    update?: boolean,
  ) => AxiosPromise<ScheduleBaseModel[]>,
] {
  const [resp, execute] = useAxios<ScheduleBaseModel[]>(
    {},
    {
      ...defaultAxiosOptions,
    },
  );

  const save = (data: ScheduleBaseModel[], update = false) =>
    execute({
      method: update ? AxiosMethod.Put : AxiosMethod.Post,
      url: endpoint,
      data,
    });

  return [resp, save];
}
